// Ortak API ayarları. Yeni kod API_URL'ü buradan almalı; eski modüllerdeki 14 kopya
// ileride buraya taşınacak (bkz. docs/PROJE-HARITASI.md §10).
export const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';

// Yazma istekleri için başlıklar. Token verilmezse Authorization eklenmez; AuthContext'teki genel fetch
// sarmalayıcısı oturumdaki token'ı kendisi ekler ("Bearer undefined" gönderilip oturum düşürülmesin).
export const jsonAuthHeaders = (token) => ({
  'Content-Type': 'application/json',
  ...(token ? { 'Authorization': `Bearer ${token}` } : {})
});

// Yanıt başarısızsa sunucunun { message } alanını taşıyan bir Error fırlatır.
export const readJsonOrThrow = async (response, fallbackMessage) => {
  let body = null;
  try { body = await response.json(); } catch (e) { /* JSON olmayan yanıt */ }
  if (!response.ok) throw new Error(body?.message || fallbackMessage || `Sunucu hatası (${response.status})`);
  return body;
};
